import { createContext, useContext, Dispatch } from 'react';

import { initialState } from './reducer';
import { ActionType, StateType } from './types';

type StoreType = {
  state: StateType;
  dispatch: Dispatch<ActionType>;
};

export const AccountProfileDispatch = createContext<StoreType>({
  state: initialState,
  dispatch: () => {},
});

export const useAccountProfileContext = (): StoreType => useContext(AccountProfileDispatch);
